<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12" md="6">
        <v-card class="card--shadow">
          <v-toolbar color="purple accent-4" dark flat>
            <v-toolbar-title class="text-uppercase">
              <v-icon class="mb-1">mdi-account-check-outline</v-icon>
              Field Officer Login
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <form @submit.prevent="login">
            <v-card-text>
              <label>Code</label>
              <v-text-field
                v-model.trim="code"
                placeholder="enter code"
                :error-messages="handleFieldErrors($v.code)"
                type="text"
                outlined
                dense
              ></v-text-field>
              <label>Password</label>
              <v-text-field
                v-model.trim="password"
                :error-messages="handleFieldErrors($v.password)"
                placeholder="enter your password"
                type="password"
                outlined
                dense
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large type="submit" class="form-btn mb-3">
                <v-icon left>mdi-chevron-right-circle-outline</v-icon>
                Login
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import loaderObj from "@/components/notification/services/Loader.js";

export default {
  mixins: [ValidationMixin],
  data() {
    return {
      password: "",
      code: "",
    };
  },
  components: {},
  validations: {
    password: {
      required,
    },
    code: {
      required,
    },
  },
  methods: {
    login() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          password: this.password,
          code: this.code,
        };
        let loader = this.$loading.show(loaderObj);
        this.$store.dispatch("Admin/login", data).then((isPass) => {
          if (isPass) {
            loader.hide();
            this.$store.dispatch("Admin/getAdmin");
            this.$router.push("/");
          } else {
            loader.hide();
          }
        });
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
